package de.katoonerie

import app.softwork.routingcompose.BrowserRouter
import de.katoonerie.components.Gradient
import de.katoonerie.content.ActionsPage
import de.katoonerie.content.AppPrivacy
import de.katoonerie.content.Footer
import de.katoonerie.content.Header
import de.katoonerie.content.Home
import de.katoonerie.content.Homepage
import de.katoonerie.content.Imprint
import de.katoonerie.content.Network
import de.katoonerie.content.NotFound
import de.katoonerie.content.Page
import de.katoonerie.content.TilesPage
import de.katoonerie.contentful.ContentfulClient
import de.katoonerie.contentful.ContentfulClient.Token.Delivery
import de.katoonerie.contentful.ContentfulClient.Token.Preview
import de.katoonerie.stylesheet.AppStylesheet
import de.katoonerie.util.toURL
import kotlinext.js.require
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.renderComposable

fun main() {
    require<Any>("./input.css")

    val contentfulClient = ContentfulClient(
        url = "https://graphql.contentful.com/content/v1/spaces/pl3ti8klt434/environments/master".toURL(),
        token = ContentfulClient.Token(
            delivery = Delivery("1RNN8GMQcFTlM5l7gtbIt4Kj-pYdpmyKvOMOYCifulE"),
            preview = Preview("72IH9kvQYPmjLlcVRY5QbYemttgbfx3PEQGo-ZcVhnc")
        )
    )

    renderComposable(rootElementId = "root") {
        Style(AppStylesheet)

        BrowserRouter(initPath = "/") { // or BrowserRouter(initPath = "/users") {
            val preview = parameters?.map?.get("preview")?.first().toBoolean()
            Homepage(contentfulClient, preview = preview) {
                Header(pages = navigationBars.map { it.page }, preview = preview)
                route("", "index", "index.html") {
                    Home()
                }
                route("netzwerk", "netzwerk.html") {
                    Network()
                }
                route("impressum", "datenschutz", "impressum.html", "datenschutz.html") {
                    Imprint(preview = preview)
                }
                route("datenschutz-app-jesus-verstehen", "datenschutz-app-jesus-verstehen.html") {
                    AppPrivacy()
                }
                route("theologie-fuer-alle", "theologie-fuer-alle.html") {
                    Page(contentfulClient, path = "theologie-fuer-alle", preview = preview) {
                        TilesPage()
                    }
                }
                route("kinderseiten", "kinderseiten.html") {
                    Page(contentfulClient, path = "kinderseiten", preview = preview) {
                        TilesPage()
                    }
                }
                route("aktionen", "aktionen.html") {
                    Page(contentfulClient, path = "aktionen", preview = preview) {
                        ActionsPage()
                    }
                }
                noMatch {
                    Gradient {
                        NotFound()
                    }
                }
                Footer(preview = preview)
            }
        }
    }
}
